import React from 'react';
import PropTypes from 'prop-types';
import { Popover, PopoverContent, PopoverTrigger } from '../../popover';
import Paragraph from '../../paragraph';

const ValuePopover = ({ value, isValuePopoverOpen, isTouchDevice, title, imgSrc, content }) => (
  <div className="ws-ui-slider-pattern__value-popover">
    <Popover
      mode={isTouchDevice ? 'popover' : 'tooltip'}
      placement="top-right"
      title={title}
      appearance="dark"
      imgSrc={imgSrc}
      isOpen={isValuePopoverOpen}
    >
      <PopoverTrigger>
        <Paragraph>{value}</Paragraph>
      </PopoverTrigger>

      <PopoverContent>{content}</PopoverContent>
    </Popover>
  </div>
);

export default ValuePopover;

ValuePopover.propTypes = {
  value: PropTypes.number.isRequired,
  isTouchDevice: PropTypes.bool.isRequired,
  isValuePopoverOpen: PropTypes.bool.isRequired,
  title: PropTypes.node.isRequired,
  content: PropTypes.node.isRequired,
  imgSrc: PropTypes.string.isRequired,
};
